module.exports = "<div ui-view=main></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/skills/skills.html
// module id = 508
// module chunks = 0